export default __webpack_public_path__ + "static/media/single-project-page-03-img07.1f3476d7.jpg";